export default {
    serverUrl: 'https://nes.yjzniubility.cn/gateway',
    // serverUrl: 'http://localhost:9999',
}
